import webui from "@tinqin/tinqin-web-ui";
export default () => {
    return dispatch => {
        const setGlobalProperty = webui.getActionByName("global.setGlobalProperty");
        dispatch(setGlobalProperty({ name: "stickyFooterClosed", value: true }));
    };
};
